<template>
  <div class="game-list">
    <GameCard
      v-for="(game, index) in games"
      :key="index"
      :image="game.image"
      :name="game.name"
      :value="game.value"
    />
  </div>
</template>

<script>
import IconCrash from "@/components/icons/IconCrash.vue";
import GameCard from "./GameCard.vue";
import IconBlackjack from "../../icons/IconBlackjack.vue";

export default {
  name: "GameList",
  components: {
    GameCard,
  },
  data() {
    return {
      games: [
        {
          image: IconCrash,
          name: "Robyn",
          value: 60,
        },
        {
          image: IconCrash,
          name: "Robyn",
          value: 54,
        },
        {
          image: IconCrash,
          name: "Robyn",
          value: 42,
        },
        {
          image: IconCrash,
          name: "Robyn",
          value: 928,
        },
        {
          image: IconBlackjack,
          name: "Robyn",
          value: 37.5,
        },
      ],
    };
  },
};
</script>

<style scoped>
.game-list {
  display: flex;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;
}
</style>
